import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcMultiFactorAuth = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M4 2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Zm5.5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-4-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
  fill: "var(--mds-nav-icon-medium)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M14 12a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-6Zm5.78 4.03a.75.75 0 1 0-1.06-1.06l-2.47 2.47-.97-.97a.75.75 0 1 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.06 0l3-3Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M13.5 8H16v2.5h2V8a2 2 0 0 0-2-2h-2.5v2ZM8 16v-2.5H6V16a2 2 0 0 0 2 2h2.5v-2H8Z",
  fill: "var(--mds-nav-icon-weak)"
})), "IcMultiFactorAuth");

export { IcMultiFactorAuth };
//# sourceMappingURL=ic-multi-factor-auth.js.map
